import React, {FC} from 'react'
import {Star} from '../../assets/icons'

interface StarPropTypes {
    filledStars: number
    remainder: number
    siteId: string
    size: string
}

const Stars: FC<StarPropTypes> = ({filledStars, remainder, siteId, size}) => {
    const starFullColor = siteId === 'HSASTORE' ? '#4FCCB1' : '#FFB19A'
    const starEmptyColor = '#D3D3D3'
    const sizeDimensions = size === 'small' ? 12 : size === 'medium' ? 14 : 18

    const renderStar = (index: number) => {
        const isFilled = index < filledStars
        const isPartial = index === filledStars && remainder > 0

        return (
            <div key={index} className="relative inline-block xs:mx-[.07rem] sm:mx-[.1rem]">
                <Star
                    fill={starEmptyColor}
                    width={sizeDimensions}
                    height={sizeDimensions}
                    data-testid="Stars"
                />
                {isFilled && (
                    <Star
                        fill={starFullColor}
                        width={sizeDimensions}
                        height={sizeDimensions}
                        className="absolute top-0 left-0"
                        data-testid="Stars"
                    />
                )}
                {isPartial && (
                    <div
                        className="absolute top-0 left-0 overflow-hidden"
                        style={{width: `${remainder * 100}%`}}
                    >
                        <Star
                            fill={starFullColor}
                            width={sizeDimensions}
                            height={sizeDimensions}
                            data-testid="Stars"
                        />
                    </div>
                )}
            </div>
        )
    }

    return <>{Array.from({length: 5}, (_, index) => renderStar(index))}</>
}

export default Stars
